<div class="search-bar" [class.has-results]="hasResults">
  <div class="input-group">
    <div class="input-group-text">
      <i-lucide name="search"></i-lucide>
    </div>
    <input
      name="searchField"
      id="searchField"
      class="form-control"
      autocomplete="off"
      type="search"
      [placeholder]="placeholder"
      [formControl]="searchField"
      (blur)="onBlur()"
      (focus)="focused = true"
    />
  </div>
  @if (hasResults && focused) {
    <div aria-labelledby="result-selection" class="results rounded">
      <div class="result-select">
        @for (result of results; track result) {
          <a
            class="title"
            type="button"
            [routerLink]="resultLink(result.id, result.title)"
            (click)="clear()"
          >
            <p class="fw-bold">{{ result.title }}</p>
            <p class="subtitle">{{ result.subtitle }}</p>
          </a>
        }

        @if (moreResultsLink) {
          <button
            type="button"
            class="btn btn-outline"
            [routerLink]="moreResultsLink"
            fragment="search"
            [queryParams]="{ searchCriteria: searchField.value }"
            (click)="clear()"
          >
            See More
          </button>
        }
      </div>
    </div>
  }
</div>
